<template>
  <div class="bg-black py-20 overflow-hidden">
    <div class="md:px-10 max-w-screen-4xl mx-auto px-6 lg:px-12">
      <div
        class="grid grid-cols-1 lg:grid-cols-2 items-center gap-6 lg:gap-12 foundation-story"
      >
        <!-- Right Content Section -->
        <div class="p-8 lg:p-10 animate-fadeIn">
          <h1 class="text-white text-3xl">
            The <span class="text-yellow">Foundation</span> Believes……
          </h1>

          <p class="text-white text-m leading-relaxed mb-4 mt-5 text-left sm:text-justify sm:max-w-prose ">
            True empowerment comes through education and digital skills; hence,
            we prioritise programs that provide modern learning opportunities to
            underserved communities.
          </p>
          <p class="text-white text-m leading-relaxed mb-4 text-left sm:text-justify sm:max-w-prose">
            We are committed to addressing essential needs by supporting the
            less privileged, particularly in Northern Nigeria, with critical
            resources such as food, shelter, clothing, and foundational
            education. These efforts ensure a well-rounded approach to
            empowerment and achievement of identified SDGs.
          </p>
          <p class="text-white text-base text-m leading-relaxed mb-4 text-left sm:text-justify sm:max-w-prose">
            Mshel Foundation operates within Nigeria and desires to extend its
            reach to other African nations and developing continents.
          </p>

          <button
            class="mt-6 px-6 py-2 bg-transparent border border-white text-white font-semibold rounded hover:bg-yellow-600 transition-colors"
            @click="animateCounters"
          >
            Learn More
          </button>
        </div>
        <!-- Right Image Section -->

        <div class="overflow-hidden h-64 md:h-96 lg:h-[500px]">
          <img
            src="../assets/images/foundation4.jpg"
            alt="Our Story"
            class="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
          />
        </div>
      </div>
    </div>
    <div class="bg-yellow-600 h-15 w-full pt-10">
      <div
        class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6 mt-10 md:px-10 px-6 lg:px-12"
      >
        <div
          class="bg-white p-6 rounded-lg shadow-lg text-center foundation-story"
        >
          <h2 class="text-3xl font-bold mb-2">{{ scholarship }}</h2>
          <p class="text-gray-600">Scholarship</p>
        </div>
        <div
          class="bg-white p-6 rounded-lg shadow-lg text-center foundation-story"
        >
          <h2 class="text-3xl font-bold mb-2">{{ outreach }}</h2>
          <p class="text-gray-600">Outreach</p>
        </div>
        <div
          class="bg-white p-6 rounded-lg shadow-lg text-center foundation-story"
        >
          <h2 class="text-3xl font-bold mb-2">{{ award }}</h2>
          <p class="text-gray-600">Awards</p>
        </div>
        <div
          class="bg-white p-6 rounded-lg shadow-lg text-center foundation-story"
        >
          <h2 class="text-3xl font-bold mb-2">{{ location }}</h2>
          <p class="text-gray-600">Location</p>
        </div>
        <div
          class="bg-white p-6 rounded-lg shadow-lg text-center foundation-story"
        >
          <h2 class="text-3xl font-bold mb-2">{{ donation }}</h2>
          <p class="text-gray-600">Donations</p>
        </div>
      </div>

      <h1 class="text-4xl text-white md:text-6xl lg:text-8xl pt-10 text-center">
        INITIA<span class="text-yellow">TIVES</span>
      </h1>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      scholarship: 0,
      outreach: 0,
      award: 0,
      location: 0,
      donation: 0,
    };
  },
  methods: {
    animateCounters() {
      const targets = {
        scholarship: 2000,
        outreach: 60,
        award: 200,
        location: 39,
        donation: 1,
      };

      // Reset counters to 0 before animating again
      Object.keys(targets).forEach((key) => {
        this[key] = 0;
      });

      Object.keys(targets).forEach((key) => {
        let count = 0;
        const step = Math.ceil(targets[key] / 100);
        const interval = setInterval(() => {
          count += step;
          if (count >= targets[key]) {
            this[key] = targets[key];
            clearInterval(interval);
          } else {
            this[key] = count;
          }
        }, 15); // Adjust speed here
      });
    },
  },
  mounted() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("fade-in");
            this.animateCounters(); // Trigger counter animation
          }
        });
      },
      {
        threshold: 0.2, // Adjust for smoother animation trigger
      }
    );

    document
      .querySelectorAll(".foundation-story")
      .forEach((card) => observer.observe(card));
  },
};
</script>

<style scoped>
/* Smooth Fade-In Animation */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.animate-fadeIn {
  animation: fadeIn 0.8s ease-out;
}

.foundation-story {
  opacity: 0;
  transform: translateY(50px);
  transition: opacity 1s ease-out, transform 1s ease-out;
  will-change: opacity, transform;
}

.foundation-story.fade-in {
  opacity: 1;
  transform: translateY(0);
}
.pt-10 {
  padding-top: 100px !important;
}
</style>
